import type { BaseComponent, Building, PhotoModel } from '../../../../types/protocols';
import { componentLocations, LocationData } from '../../../../Helpers/componentLocations';
import { orderPhotos } from '../../../../Helpers/photoOrdering';

/**
 * One picture of a component in the Massredigering list: where it is
 * (a position marker, opened in LocationModal) or what it looks like
 * (one of its own photos, opened in the Fancybox gallery).
 */
export type ComponentMedia =
    | { kind: 'position'; key: string; location: LocationData }
    | { kind: 'photo'; key: string; photo: PhotoModel };

/**
 * Everything the list can show for a component, in one order: its positions
 * as `componentLocations` gives them (photo pins, map, drawing, the room's pin),
 * then its own photos newest first. The first item is the primary thumbnail.
 * Empty when the component has neither.
 */
export const componentMediaList = (component: BaseComponent, building: Building): ComponentMedia[] => {
    const positions: ComponentMedia[] = componentLocations(component, building).map((location, index) => ({
        kind: 'position',
        key: `position-${location.type}-${location.imageKey ?? location.parentKey ?? location.storagePath}-${index}`,
        location
    }));
    const photos: ComponentMedia[] = orderPhotos(component.photos ?? {}).map(photo => ({
        kind: 'photo',
        key: `photo-${photo.key}`,
        photo
    }));
    return [...positions, ...photos];
};
